import React, { Component } from "react";

export default class DefaultTemplate extends Component {
    render() {
        const regions = this.props.regions || {};
        const children = Object.values(regions);

        if (children.length) {
            return <div className="tq-content tq-with-header">{children}</div>;
        }
        return <div />;
    }
}
